<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Branch Management 
          </v-toolbar-title>
          <v-spacer></v-spacer>  
          <v-card-actions class="justify-center">
            <!-- Godawn -->
            <router-link style="text-decoration: none;" v-if="$route.path!='/offshoot'" to="/offshoot">
              <v-btn  large outlined style="margin: 0px 15px;">
                <v-icon left color='teal'>store</v-icon>
                  Visit Branch
              </v-btn>
            </router-link>
            <!-- New Godawn-->
            <v-btn 
              @click="getFirms"
              outlined
              large>
              <v-icon left color='teal'>add</v-icon> 
              New Branch  
            </v-btn>
          </v-card-actions>
        </v-toolbar>  
        
        <v-card>
            <template v-for="(item, index) in getBranchAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <v-card-title class="body-1 primary--text font-weight-light" col>
                  <v-flex xs11> 
                    Firm:  &nbsp; <b class="font-weight-bold">{{firmbyId(item.firm)}}</b>  
                    <v-spacer/>
                    Branch Name: &nbsp; <b class="font-weight-bold">{{item.branchName}}</b> 
                    <v-spacer/>
                    Branch Address: &nbsp; <b class="font-weight-bold">{{item.branchAddress}}</b> 
                    <v-spacer/>
                    Branch Pincode: &nbsp; <b class="font-weight-bold">{{item.branchPincode}}</b> 
                    <v-spacer/>
                    Mobile Number: &nbsp; <b class="font-weight-bold">{{item.branchMobileNumber}}</b>
                    <v-spacer/>
                    Email: &nbsp; <b class="font-weight-bold">{{item.branchEmail || '-'}}</b>
                  </v-flex>

                  <v-flex xs1>
                    <v-btn flat icon class="primary white--text" @click="editBranchAccount(item)">
                      <v-icon color="grey white--text">edit</v-icon>
                    </v-btn>  
                    <v-btn flat icon class="primary white--text" @click="deleteBranchAccount(item['.key'])">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-card-title>
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Branch</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
        <v-text-field label="Branch Name" v-model="branchName" ></v-text-field>
        <v-text-field label="Branch Address" v-model="branchAddress" ></v-text-field>
        <v-text-field label="Branch Pincode" v-model="branchPincode" ></v-text-field>
        <v-text-field label="Mobile Number" :rules="branchMobileNumber.rules" v-model="branchMobileNumber.value" ></v-text-field>
        <v-text-field label="Email" :rules="branchEmail.rules" v-model="branchEmail.value" ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="addNewBranchAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogEdit" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Edit Branch Details</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="itemsEdit"
          v-model="currentFirmEdit"
          label="Edit Firm"
          ></v-select>
          <v-text-field label="Edit Branch Name" v-model="branchNameEdit" ></v-text-field>
          <v-text-field label="Edit Branch Address" v-model="branchAddressEdit" ></v-text-field>
          <v-text-field label="Edit Branch Pincode" v-model="branchPincodeEdit" ></v-text-field>
          <v-text-field label="Edit Mobile Number" :rules="branchMobileNumberEdit.rules" v-model="branchMobileNumberEdit.value" ></v-text-field>
          <v-text-field label="Edit Email" :rules="branchEmailEdit.rules" v-model="branchEmailEdit.value" ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialogEdit">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="updateNewBranchAccount">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-snackbar
      v-model="snackbar"
      top
      color="error"
      :timeout="3000"
    >
   {{snackbarText}}
    </v-snackbar>
    <v-snackbar
      v-model="snackbarSuccess"
      top
      color="success"
      :timeout="3000"
    >
   {{snackbarSuccessText}}
    </v-snackbar>
  </v-layout>

</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Branch',
  data () {
    return {
      dialog: false,
      dialogEdit: false,
      items:null,
      currentFirm:"",
      branchName: null,
      branchAddress: null,
      branchPincode: 0,
      branchNameEdit: null,
      branchAddressEdit: null,
      branchPincodeEdit: null,
      firms: [],
      snackbarSuccessText:null,
      snackbarText:null,
      snackbar : false,
      snackbarSuccess:false,
      currentFirmEdit:null,
      itemsEdit:null,
      branchMobileNumber: {
        value: null,
        rules: [
          v => !!v || 'Mobile is required',
            v => /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
        ]
      },
      branchMobileNumberEdit: {
        value: null,
        rules: [
          v => !!v || 'Mobile is required',
            v => /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
        ]
      },
      branchEmail : {
        value: '',
        rules: [
          v =>  /^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
        ],
      },
      branchEmailEdit : {
        value: '',
        rules: [
          v =>  /^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
        ],
      },
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'branch',
      this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getBranchAccount () {
      if (this.selectedBrand) {
        return this.branch.filter(item => item['brand'] === this.selectedBrand && item['firm'] != '')
      }
    },
    branchCount () {
      return this.getBranchAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewBranchAccount () {
          let data ={
            brand:this.selectedBrand,
            firm:this.currentFirm,
            branchName:this.branchName,
            branchAddress: this.branchAddress,
            branchPincode: this.branchPincode,
            branchEmail: this.branchEmail.value,
            branchMobileNumber: this.branchMobileNumber.value,
          }
      if(data.firm == null || data.firm == ""){    
        this.snackbar = true;
        this.snackbarText = 'Please Select Firm';
        return false;
      } else if(data.branchName == null || data.branchName == ""){    
        this.snackbar = true;
        this.snackbarText = 'Enter Branch Name';
        return false;
      }
        this.$root.$firebaseRefs.branch.push(data);
        this.dialog=false;
        this.currentFirm="";
        this.branchName="";
        this.branchAddress="";
        this.branchPincode=0;
        this.branchMobileNumber.value=0;
        this.branchEmail.value="";
    },
    editBranchAccount(key){
      this.dialogEdit = true;
      console.log(key)
      let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.itemsEdit = totalitem;
      this.dialogEdit=true;
      this.currentFirmEdit= key.firm;
      this.branchNameEdit=key.branchName;
      this.branchPincodeEdit=key.branchPincode;
      this.branchAddressEdit=key.branchAddress;
      this.branchMobileNumberEdit.value=key.branchMobileNumber;
      this.branchEmailEdit.value=key.branchEmail; 
      this.updateKey=key['.key']
    },
    updateNewBranchAccount(){
      let data ={
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          branchName:this.branchNameEdit,
          branchAddress: this.branchAddressEdit,
          branchPincode: this.branchPincodeEdit,
          branchEmail: this.branchEmailEdit.value,
          branchMobileNumber: this.branchMobileNumberEdit.value
        }
        this.$root.$firebaseRefs.branch.child(this.updateKey).update({
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          branchName:this.branchNameEdit,
          branchAddress: this.branchAddressEdit,
          branchPincode: this.branchPincodeEdit,
          branchEmail: this.branchEmailEdit.value,
          branchMobileNumber:  this.branchMobileNumberEdit.value 
        });
        this.currentFirmEdit="";
        this.branchNameEdit="";
        this.branchAddressEdit="",
        this.branchPincodeEdit="",
        this.branchEmailEdit.value="",
        this.branchMobileNumberEdit.value="";
        this.cancelDialogEdit();
    },

    deleteBranchAccount(key){
      confirm('Are you sure you want to delete this Branch Account') &&
      this.$root.$firebaseRefs.branch.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    cancelDialogEdit(){
      this.dialogEdit = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
        this.itemsEdit = totalitem;
    },
    getBranchAccount () {
      this.dialog =true;
        let branch = this.branch.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        branch.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Branch/Branch.vue